import { createSlice, createAction } from '@reduxjs/toolkit';

export const sendBulkWhatsappRequest = createAction('SEND_BULK_WHATSAPP');
export const createCampaignRequest = createAction('CREATE_CAMPAIGN');

const initialState = {
  selectedTemplateId: null,
  manualNumbers: "",
  importedRecipients: [],
  importSource: null,
  importCsv: null,
  importCsvFileName: null,
  templateParams: { header: {}, body: {}, button: {} },
  sendMediaFile: null,
  sendMediaFileName: null,
  useCase: '',
  useCaseId: '',
  status: "idle",
  error: null,
  csvColumns: [],
  csvData: [],
  variableMapping: {},
  phoneColumn: '',
};

const sendMessageSlice = createSlice({
  name: 'sendMessage',
  initialState,
  reducers: {
    setTemplate: (state, action) => {
      state.selectedTemplateId = action.payload;
    },
    setManualNumbers: (state, action) => {
      state.manualNumbers = action.payload;
    },
    setImportData: (state, action) => {
      state.importedRecipients = action.payload.recipients;
      state.importSource = action.payload.source;
      state.importCsv = action.payload.csv || null;
      state.importCsvFileName = action.payload.fileName || null;
    },
    clearImport: (state) => {
      state.importedRecipients = [];
      state.importSource = null;
      state.importCsv = null;
      state.importCsvFileName = null;
      state.csvColumns = [];
      state.csvData = [];
      state.variableMapping = {};
      state.phoneColumn = '';
    },
    startSending: (state) => {
      state.status = "sending";
      state.error = null;
    },
    sendingSuccess: (state) => {
      state.status = "success";
      state.manualNumbers = "";
      state.importedRecipients = [];
      state.importSource = null;
      state.templateParams = { header: {}, body: {}, button: {} };
      state.sendMediaFile = null;
      state.sendMediaFileName = null;
    },
    sendingError: (state, action) => {
      state.status = "error";
      state.error = action.payload;
    },
    setTemplateParams: (state, action) => {
      state.templateParams = action.payload;
    },
    setSendMediaFile: (state, action) => {
      state.sendMediaFile = action.payload;
    },
    setSendMediaFileName: (state, action) => {
      state.sendMediaFileName = action.payload;
    },
    setUseCase: (state, action) => {
      const { useCase, useCaseId } = action.payload || {};
      if (useCase !== undefined) state.useCase = useCase;
      if (useCaseId !== undefined) state.useCaseId = useCaseId;
    },
    clearSendMedia: (state) => {
      state.sendMediaFile = null;
      state.sendMediaFileName = null;
    },
    setCsvColumns: (state, action) => {
      state.csvColumns = action.payload;
    },
    setCsvData: (state, action) => {
      state.csvData = action.payload;
    },
    setVariableMapping: (state, action) => {
      state.variableMapping = { ...state.variableMapping, ...action.payload };
    },
    setPhoneColumn: (state, action) => {
      state.phoneColumn = action.payload;
    },
    resetStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
    resetForm: () => initialState,
  }
});

export const { 
  setTemplate, setManualNumbers, setImportData, clearImport, 
  startSending, sendingSuccess, sendingError, resetStatus, setTemplateParams,
  setSendMediaFile, setSendMediaFileName, setUseCase, clearSendMedia,
  setCsvColumns, setCsvData, setVariableMapping, setPhoneColumn,
  resetForm
} = sendMessageSlice.actions;

export default sendMessageSlice.reducer;